import { BaseRestoreFormsModel } from 'wizards/models/base/base-restore-forms-model';
import { RestoreDisksStepValue } from 'wizards/models/restore-disks-models';
import { RestoreSourceStepValue } from 'wizards/models/restore-source-models';
import { SelectHostStepValue } from 'wizards/models/select-host-models';
import { RestoreAsDiskEnum, TypeDataStepValue } from 'wizards/models/type-data-models';
import { DestinationVMStepValue } from '../destination-vm-models';

export class RestoreProxmoxFormModel extends BaseRestoreFormsModel {
  typeDataStep: TypeDataStepValue = {
    restoreAs: RestoreAsDiskEnum.RestoreToProxmox,
    selectedFileFormat: this.fileFormats[0],
    valid: true
  };
  restoreSourceStep: RestoreSourceStepValue = { folders: [], point: '', valid: true };
  selectHostStep: SelectHostStepValue = { server: '', login: '', password: '', remember: true, host: '', valid: true };

  restoreDisksStep: RestoreDisksStepValue = null;

  destinationStep: DestinationVMStepValue = {
    destinationFolder: '',
    valid: true
  };

  constructor() {
    super(true);
  }
}
